export const _MESSAGES = {
  required: "This field is required!",
  positive: "This field must be > 0",
  success: "The form has been submitted successfully! Try to submit more!",
};
